let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c6klk")).then(() => parcelRequire('5kAX9'));